import 'jquery-csv';
import * as moment from 'moment';

export default {
  init() {

	function setPostcode() {

		let postcode = localStorage.getItem('postcode'),
			suburb = localStorage.getItem('suburb');

		if ( postcode != '' || postcode != null ) {
			$('#input_1_3').val(postcode);
			$('#input_1_2').val(suburb);
			postcodeBookingCheck(postcode);
		}

	}

	setPostcode();

    // Fixed Header
	$(window).on('scroll', () => {
		if ( $(window).width() > 768 ) {
			if ( $(window).scrollTop() > 0 ) {
				$('.site-header').addClass('scrolled');
			} else {
				$('.site-header').removeClass('scrolled');
			}
		}
	});

	// Mobile Hamburger Navigation Toggle
	$(document).on('click', '.site-header__hamburger', function(){
		$('.site-header__off-canvas, .site-header__hamburger').toggleClass('active');
	});

	// Postcode Box changes
	$(document).on('keyup blur paste', '#input_1_3', function(){

		let postcode = $(this).val();

		if ( postcode.length == 4 ) {
			if ( postcode != '' ) {
				$(this).removeClass('error');
				localStorage.setItem('postcode', postcode);
				postcodeBookingCheck(postcode);
			} else {
				$(this).addClass('error');
			}
		} else {
			$('.booking__form').addClass('loading');
		}

	});

	// Validate Mattress + Bases
	$(document).on('blur', '#input_1_15', function(){

		validateMattressBase();

	});

	// Validate Mattress + Bases
	$(document).on('blur', '#input_1_23_1', function(){

		validateMattressBase();

	});

	function validateMattressBase() {
		let mattress = $('#input_1_7-1-1').val();
		let base = $('#input_1_10-2-1').val();

		if ( mattress == '' && base == '' ) {
			$('html, body').animate({scrollTop: $('#input_1_7-1-1').offset().top - 135}, 500);
			if ( $('#field_1_7-1-1 .validation_message').length == 0 ) {
				$('#field_1_7-1-1').append('<div class="gfield_description validation_message">Please choose a Mattress or Base</div>');
			}
			if ( $('#field_1_10-2-1 .validation_message').length == 0 ) {
				$('#field_1_10-2-1').append('<div class="gfield_description validation_message">Please choose a Mattress or Base</div>');
			}
			$('.booking__form').addClass('invalid');
		} else {
			$('#field_1_7-1-1 .validation_message').remove();
			$('#field_1_10-2-1 .validation_message').remove();
			$('.booking__form').removeClass('invalid');
		}
	}

	function mattressChange() {

		let cost = calculateTotal();
		let html = '';
		let quantity = $('.gfield[data-repeater-parentid="1"]').length;

		validateMattressBase();

		if ( $(this).val() != '' ) {
			$('.booking__price-total').text('$'+cost+'.00');
			$('.final-total').text('$'+cost+'.00');
			$('#input_1_36').val('$ '+cost+'.00');
			$('.gfield[data-repeater-parentid="1"]').each(function(){
				let name = $('select option:selected', this).text();
				let c = $('select', this).val();
				let dollar = 0;
				if ( c == 'Single Mattress' || c == 'King Single Mattress' ) {
					dollar = 20;
				} else if ( c == 'Double Mattress (inner spring)' || c == 'Queen Mattress (inner spring)' ) {
					dollar = 25
				} else {
					dollar = 50;
				}
				html += '<span class="left">'+name+'</span><span class="right">$'+dollar+'.00</span>';
				$('.booking__totals-mattresses').html(html).addClass('show');
			});
		} else {
			$('.booking__price-total').text('$'+cost+'.00');
			$('.final-total').text('$'+cost+'.00');
			$('#input_1_36').val('$ '+cost+'.00');
			if ( quantity == 1 ) {
				$('.booking__totals-mattresses').html('').removeClass('show');
			}
		}

	}

	function basesChange() {

		let cost = calculateTotal();
		let html = '';
		let quantity = $('.gfield[data-repeater-parentid="2"]').length;

		validateMattressBase();

		if ( $(this).val() != '' ) {
			$('.booking__price-total').text('$'+cost+'.00');
			$('.final-total').text('$'+cost+'.00');
			$('#input_1_36').val('$ '+cost+'.00');
			$('.gfield[data-repeater-parentid="2"]').each(function(){
				let name = $('select option:selected', this).text();
				let c = $('select', this).val();
				let dollar = 0;
				if ( c == 'Single Base' || c == 'King Single Base' ) {
					dollar = 20;
				}
				else if ( c == 'Double Base' || c == 'Queen Base' ) {
					dollar = 25
				} else {
					dollar = 45;
				}
				html += '<span class="left">'+name+'</span><span class="right">$'+dollar+'.00</span>';
				$('.booking__totals-bases').html(html).addClass('show');
			});
		} else {
			$('.booking__price-total').text('$'+cost+'.00');
			$('.final-total').text('$'+cost+'.00');
			$('#input_1_36').val('$ '+cost+'.00');
			if ( quantity == 1 ) {
				$('.booking__totals-bases').html('').removeClass('show');
			}
		}

	}

	// Mattress
	$(document).on('change', '.gfield[data-repeater-parentid="1"] select', function(e){

		e.preventDefault();

		mattressChange();

	});

	function calculateTotal() {
		let zone = $('#input_1_3').attr('data-zone-price');
		let mattresses = 0;
		let bases = 0;
		let total = 0;
		let mPrice = 0;
		let bPrice = 0;
		$('.gfield[data-repeater-parentid="1"] select').each(function(){
			if ( $(this).val() == '' || $(this).val() == null || $(this).val() == undefined ) {
				mattresses += parseInt( 0 );
			} else {
				if ( $(this).val() == 'Single Mattress' || $(this).val() == 'King Single Mattress' ) {
					mPrice = 20;
				} else if ( $(this).val() == 'Double Mattress (inner spring)' || $(this).val() == 'Queen Mattress (inner spring)' ) {
					mPrice = 25
				} else {
					mPrice = 50;
				}
				mattresses += parseInt( mPrice );
			}
		});
		$('.gfield[data-repeater-parentid="2"] select').each(function(){
			if ( $(this).val() == '' || $(this).val() == null || $(this).val() == undefined ) {
				bases += parseInt( 0 );
			} else {
				if ( $(this).val() == 'Single Base' || $(this).val() == 'King Single Base' ) {
					bPrice = 20;
				} else if ( $(this).val() == 'Double Base' || $(this).val() == 'Queen Base' ) {
					bPrice = 25
				} else {
					bPrice = 45;
				}
				bases += parseInt( bPrice );
			}

		});

		total = parseInt(mattresses) + parseInt(bases) + parseInt(zone);
		return total;
	}

	function validatedForm() {
		let zone = $('#input_1_3').attr('data-zone-price');
		let mattresses = 0;
		let bases = 0;
		let total = 0;
		let mHtml = '';
		let bHtml = '';
		$('.gfield[data-repeater-parentid="1"] select').each(function(){
			if ( $(this).val() == '' || $(this).val() == null || $(this).val() == undefined ) {
				mattresses += parseInt( 0 );
			} else {
				let name = $('option:selected', this).text();
				let c = $(this).val();
				let dollar = 0;
				if ( c == 'Single Mattress' || c == 'King Single Mattress' ) {
					dollar = 20;
				} else if ( c == 'Double Mattress (inner spring)' || c == 'Queen Mattress (inner spring)' ) {
					dollar = 25
				} else {
					dollar = 50;
				}
				mattresses += parseInt( dollar );
				mHtml += '<span class="left">'+name+'</span><span class="right">$'+dollar+'.00</span>';
				$('.booking__totals-mattresses').html(mHtml).addClass('show');
			}
		});
		$('.gfield[data-repeater-parentid="2"] select').each(function(){
			if ( $(this).val() == '' || $(this).val() == null || $(this).val() == undefined ) {
				bases += parseInt( 0 );
			} else {
				let name = $('option:selected', this).text();
				let c = $(this).val();
				let dollar = 0;
				if ( c == 'Single Base' || c == 'King Single Base' ) {
					dollar = 20;
				}
				else if ( c == 'Double Base' || c == 'Queen Base' ) {
					dollar = 25
				} else {
					dollar = 45;
				}
				bases += parseInt( dollar );
				bHtml += '<span class="left">'+name+'</span><span class="right">$'+dollar+'.00</span>';
				$('.booking__totals-bases').html(bHtml).addClass('show');
			}

		});

		total = parseInt(mattresses) + parseInt(bases) + parseInt(zone);
		return total;
	}

	// Bases
	$(document).on('change', '.gfield[data-repeater-parentid="2"] select', function(e){

		e.preventDefault();

		basesChange();

	});

	// Remove mattress
	$(document).on('click', '#field_1_6 .gf_repeater_remove', () => {
		$('.booking__totals-mattresses span.right:last-of-type').remove();
		$('.booking__totals-mattresses span.left:last-of-type').remove();
		mattressChange();
	});

	// Remove base
	$(document).on('click', '#field_1_11 .gf_repeater_remove', () => {
		$('.booking__totals-bases span.right:last-of-type').remove();
		$('.booking__totals-bases span.left:last-of-type').remove();
		basesChange();
	});

	$(document).on('keyup blur paste', '#input_1_2', function(){

		var suburb = $(this).val();
		$('#input_1_19').val(suburb);

	});

	$('.map__form').on('submit', function(e){
		e.preventDefault();
		var postcode = $('.map__input[name="postcode"]', this).val();
		if ( postcode != '' ) {
			$(this).removeClass('error');
			postcodeCheck(e, postcode);
		} else {
			$(this).addClass('error');
		}

	});

	$('.suburbs__button').click(function(e){
		e.preventDefault();
		$(this).hide();
		$('.suburbs').addClass('max-height');
	});

	$('.recycle__form').on('submit', function(e){
		e.preventDefault();
		var postcode = $('.map__input[name="postcode"]', this).val();
		if ( postcode != '' ) {
			$(this).removeClass('error');
			postcodeCheck(e, postcode);
		} else {
			$(this).addClass('error');
		}
	});

	function postcodeCheck(e, sub) {

		let count = 0;

		$('.map__results').removeClass('success');
		$('.map__results').removeClass('fail');

		var suburbs = {},
			result = [];

		$.ajax({
			url: siteOptions.suburbs,
			success: function (csvd) {
				suburbs = $.csv.toObjects(csvd);
			},
			dataType: "text",
			complete: function () {

				// call a function on complete

				result = $.grep(suburbs, function(obj) {
					return obj.postcode === sub;
				});

				count = result.length;

				if (count > 0) {

					$('.map__results').addClass('success');
					$('.map__results .result').text("Yes we deliver to "+result[0].suburb+".");
					$('.map__results .price').text(result[0].cost);
					localStorage.setItem('postcode', result[0].postcode);
					localStorage.setItem('suburb', result[0].suburb);

					if ( $('.recycle__results').hasClass('success') ) {
						window.location = siteOptions.url+'/book-collection';
					}

				} else {

					$('.map__results').addClass('fail');
					$('.map__results .result').text("Sorry! We don't deliver to that suburb. Please try again.");

				}

			},
		});


	}

	function postcodeBookingCheck(sub) {

		let count = 0;

		$('.booking__form').addClass('loading');

		var suburbs = {},
			result = [];

		$.ajax({
			url: siteOptions.suburbs,
			success: function (csvd) {
				suburbs = $.csv.toObjects(csvd);
			},
			dataType: "text",
			complete: function () {

				// call a function on complete

				result = $.grep(suburbs, function(obj) {
					return obj.postcode === sub;
				});

				count = result.length;

				if (count > 0) {

					$('.booking__form').removeClass('loading');
					$('#input_1_2').val(result[0].suburb);
					$('#input_1_19').val(result[0].suburb);
					$('#input_1_20').val(result[0].postcode);
					localStorage.setItem('suburb', result[0].suburb);

					let cost = Number(result[0].cost.replace(/[^0-9]/g,""));
					$('#input_1_3').attr('data-zone-price', cost);
					let totalCost = calculateTotal();

					$('.booking__price-total').text('$'+totalCost+'.00');
					$('.call-out-price').text('$'+cost+'.00');
					$('.final-total').text('$'+totalCost+'.00');
					$('#input_1_36').val('$ '+totalCost+'.00');

					let zone = result[0].zone;

					console.log(zone);

					//let day = '';
					var currentDay = moment().parseZone('Australia/Melbourne').day();

					let pickupDate = '';

					if ( currentDay < zone && currentDay != 0 ) {
						pickupDate = moment().isoWeekday(parseInt(zone)).format('dddd, DD MMMM, YYYY');
					} else {
						pickupDate = moment().isoWeekday(parseInt(zone)).add(7, 'days').format('dddd, DD MMMM, YYYY');
					}

					$('.booking__date-text').text(pickupDate);
					$('#input_1_33').val(pickupDate);
					$('#input_1_34').val(parseInt(zone));

				} else {

					$('.booking__form').addClass('loading');

				}

			},
		});

		if ( $('.validation_message').length > 0 ) {
			$('html, body').animate({scrollTop: $('.validation_message:first').offset().top - 135}, 500);
			setTimeout(function(){
				let grandTotal = validatedForm();
				$('.booking__price-total').text('$'+grandTotal+'.00');
				$('.final-total').text('$'+grandTotal+'.00');
				$('#input_1_36').val('$ '+grandTotal+'.00');
			}, 100);

		}

	}

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js